import Component from 'ShopUi/models/component';
import Konami from 'konami';

export default class LouisBike extends Component {

    private readonly startTimeout = 500;
    private readonly removeTimeout = 3000;

    protected init(): void {
        this.remove();

        Konami((): void => {
            const div = document.createElement('div');

            div.className = 'louis-bike';
            document.body.appendChild(div);

            setTimeout((): void => {
                div.className += ' louis-bike-running';
            }, this.startTimeout);

            setTimeout((): void => {
                div.remove();
            }, this.removeTimeout);
        });
    }

    protected readyCallback(): void {
    }
}
